<template>
	<div class="mobile-header" :class="isSafari ? 'safari' : ''">
		<div class="mobile-header__logo">
			<MenuLogo />
		</div>
		<div class="mobile-header__icon" :class="isSafari ? 'safari' : ''" @click="handleSidebar()">
			<MobileIcon />
		</div>
	</div>
</template>

<script>
import MenuLogo from '@/components/shared/Icons/MenuLogo.vue';
import MobileIcon from '@/components/shared/Icons/MobileIcon.vue';

export default {
	name: 'MobileHeader',
	components: {
		MenuLogo,
		MobileIcon,
	},
	data: () => ({
		title: '',
	}),
	mounted() {},
	methods: {
		handleSidebar() {
			this.$emit('handleSidebar');
		},
	},
	computed: {
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
	watch: {
		$route: {
			handler(route) {
				this.title = route.name;
			},
			deep: true,
			immediate: true,
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'MobileHeader.scss';
</style>
